<template>
    <div class="page" v-show="bodyShow">
        <div  class="cover">
            <van-image
                fit="cover"
                height="210px"
                :src="detail.cover_url"
            />
            <div class="cover_recent" @click="bindToPhase(detail.training_stage_id)">
                <div class="cover_recent_name">{{detail.stage_name}}</div>
                <div class="cover_recent_desc">{{detail.stage_description}}</div>
            </div>
        </div>
        <div class="date">
            <div class="date_time"><span class="iconfont icontime mr5"></span></div>
            <div v-if="detail.stage_business_status==2">报名已截止</div>
            <div v-if="detail.stage_business_status==1">截止报名：<van-count-down millisecond :time="time" format="DD 天 HH 时 mm 分 ss 秒" /></div>
            <div v-if="detail.stage_business_status==3">报名日期：{{detail.stage_registration_start_time_cn}}</div>
            <div v-if="0 && detail.stage_business_status==1 && detail.stage_limit_day">距离开课 <span class="color_red" >{{detail.stage_limit_day}}</span> 天</div>
        </div>
        <div class="info">
            <div class="info_left" >
                <div class="info_left_item">
                    <div class="info_left_num">{{detail.stage_task_day}}</div>
                    <div class="info_left_text">天</div>
                </div>
                <div class="info_left_item">
                    <div class="info_left_num">{{detail.stage_task_sections}}</div>
                    <div class="info_left_text">任务</div>
                </div>
            </div>
            <div class="info_right train-user" @click="bindToStudents">
                <div class="train-user-logo">
                    <img :class="'train-user-img '+(index >0?'mlf15':'')" v-for="(item,index) in detail.training_enter_users" :key="index"
                            :src="item.photo"/>
                </div>
                <div class="train-user-col">
                    <template v-if="detail.training_enter_users_cnt>5">
                        等{{detail.training_enter_users_cnt}}人参与
                    </template>
                    <template v-else-if="detail.training_enter_users_cnt<5 && detail.training_enter_users_cnt>0">
                        {{detail.training_enter_users_cnt}}人参与
                    </template>
                    <template v-else >
                        暂无人参与
                    </template>
                </div>
            </div>
        </div>
        <div class="teacher">
            <div class="teacher-list"  v-for="(item,index) in detail.lecturers" :key="index" >
                <div class="teacher-main-wrap">
                    <div class="teacher-main">
                        <div class="top_left">
                            <img :src="item.photo" alt="">
                        </div>
                        <div class="top_right">
                            <div class="top_right_name">{{item.user_name}}</div>
                            <div class="top_right_position font-spacing">{{item.job}}</div>
                            <div class="top_right_desc font-spacing">{{item.company}}</div>
                        </div>
                    </div>
                </div>

                
            </div>
        </div>
        <div class="detail">
            <div class="detail-content" v-html="detail.content"></div>
        </div>
        <div v-if="detail.stage_same_term.length > 0" class="section">同期训练营</div>
        <div v-if="detail.stage_same_term.length > 0" class="sameterm">
            <div class="sameterm-content" v-for="(term_item,term_index) in detail.stage_same_term" :key="term_index">
                <div class="sameterm-name">{{term_item.name}}</div>
                <div class="sameterm-desc">{{term_item.description}}</div>
                <div class="sameterm-time"><span class="iconfont icontime mr5"></span> 报名日期： {{term_item.registration_start_time_cn}} - {{term_item.registration_end_time_cn}}</div>
                <div class="sameterm-info-wrap">
                    <div class="sameterm-info">
                        <div class="sameterm-info-item">
                            <div class="sameterm-info-num">{{term_item.stage_task_day}}</div>
                            <div class="sameterm-info-text">天</div>
                        </div>
                        <div class="sameterm-info-item">
                            <div class="sameterm-info-num">{{term_item.stage_task_sections}}</div>
                            <div class="sameterm-info-text">任务</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="bottom">
            <div class="bottom-info" >
                <div class="bottom-name">{{detail.stage_name}}</div>
                <div class="bottom-study-time">
                    <span class="bottom-study-unit">开课日期：{{detail.stage_study_start_date}}</span>
                </div>
                <div v-if="detail.sell_mode==1" class="bottom-price">
                    <span class="bottom-price-unit color_red">限时价:￥</span>
                    <span class="bottom-price-num color_red">{{detail.money}}</span> 
                    <template v-if="!(detail.promotion_money == 0 || detail.promotion_money == '0.00')"> 
                        <span class="bottom-price-mark">原价：</span>
                        <span class="bottom-price-mark-num">￥{{detail.promotion_money}}</span>
                    </template>
                </div>
                <div v-if="detail.sell_mode==2" class="bottom-price">
                    <span class="bottom-price-unit color_red">限时免费</span>
                </div>

            </div>
            <div class="bottom-op">
                <!-- 一个营期情况 -->
                <template v-if="detail.stage_same_term.length == 0 && detail.stage_is_own==0">
                    <template v-if="detail.stage_apply_status == 1">
                        <van-button  @click="bandOrder(detail.training_stage_id,detail)" round color="linear-gradient(to right, #ff6034, #ee0a0a)" size="small">加入学习</van-button>
                    </template>
                    <template v-if="detail.stage_apply_status == 3">
                        <van-button  round color="linear-gradient(to right, #ff6034, #ee0a0a)" size="small">报名未开始</van-button>
                    </template>
                    <template v-if="detail.stage_apply_status == 2">
                        <van-button plain  round type="warning" disabled  size="small">报名已截止</van-button>
                    </template>
                </template>
                <van-button  v-if="detail.stage_same_term.length == 0 && detail.stage_is_own==1" @click="bindToPhase(detail.training_stage_id)" round color="linear-gradient(to right, #ff6034, #ee0a0a)" size="small">去学习</van-button>
                <!-- 多个营期情况 -->
                <van-button  v-if="detail.stage_same_term.length > 0 " @click="bandOpenPop" round color="linear-gradient(to right, #ff6034, #ee0a0a)" size="small">选择营期</van-button>
                
            
            </div>
        </div>

        <van-popup
            v-model="popup_show"
            position="bottom"
            closeable
            :style="{ height:'50%', borderRadius: '7px 7px 0 0' }"
            >
            <div style="padding:35px 20px 20px;">
                <template v-for="(price_item,price_index) in stage_same_term_price" >
                    <div class="term-item"   :key="price_index"  >
                        <div class="bottom-info" >
                        <div class="bottom-name">{{price_item.stage_name}}</div>
                        <div class="bottom-study-time">
                        <span class="bottom-study-unit">开课日期：{{price_item.stage_study_start_date}}</span>
                        </div>
                        <div v-if="price_item.sell_mode==1" class="bottom-price">
                            <span class="bottom-price-unit color_red">限时价:￥</span>
                            <span class="bottom-price-num color_red">{{price_item.money}}</span>  
                            <template v-if="!(price_item.promotion_money == 0 || price_item.promotion_money=='0.00')">
                                <span class="bottom-price-mark">原价：</span>
                                <span class="bottom-price-mark-num">￥{{price_item.promotion_money}}</span>
                            </template>
                        </div>
                        <div v-if="price_item.sell_mode==2" class="bottom-price">
                            <span class="bottom-price-unit color_red">限时免费</span>
                        </div>
                        </div>
                        <div class="bottom-op">
                            <template v-if=" price_item.stage_is_own==0">
                                <template v-if="price_item.stage_apply_status == 1">
                                    <van-button  @click="bandOrder(price_item.training_stage_id,price_item)" round color="linear-gradient(to right, #ff6034, #ee0a0a)" size="small">加入学习</van-button>
                                </template>
                                <template v-if="price_item.stage_apply_status == 3">
                                    <van-button  round color="linear-gradient(to right, #ff6034, #ee0a0a)" size="small">报名未开始</van-button>
                                </template>
                                <template v-if="price_item.stage_apply_status == 2">
                                    <van-button plain  round type="warning" disabled  size="small">报名已截止</van-button>
                                </template>
                            </template>
                            
                            <van-button v-if="price_item.stage_is_own==1" @click="bindToPhase(price_item.training_stage_id)" round color="linear-gradient(to right, #ff6034, #ee0a0a)" size="small">去学习</van-button>
                        </div>
                    </div>
                    <van-divider :key="price_index"  />
                </template>
            </div>
        </van-popup>
        
        <authorize_mobile v-on:usergrantcallback="usergrantcallback" :visible="visible"></authorize_mobile>
    </div>
</template>
<script>
import {Image as VanImage,Button,Popup,Divider,Toast ,Field,Checkbox,Icon,ActionSheet,ImagePreview,Dialog,Loading,Swipe, SwipeItem, CountDown} from 'vant';
import authorize_mobile from '../../components/common/authorize_mobile';
export default {
        name: "index",
        components:{
           [VanImage.name]:VanImage,
           [CountDown.name]:CountDown,
           [Divider.name]:Divider,
           [Button.name]:Button,
           [Popup.name]:Popup,
           [Toast.name]:Toast,
           authorize_mobile
        },
        data(){
            return {
                visible:false,
                bodyShow: false,
                popup_show: false,
                training_id: '',
                detail: {
                    training_id:'2',
                    stage_name: "营销一期营",
                    stage_description: "新媒体社群运营实战系统班/社群营销/拉新/促活/成交/裂变/网赚",
                    cover: "https://img.fincgo.com/mall/16/20200904/86/5f51da5237c05.jpg",
                    cover_url: "https://img.fincgo.com/mall/2/20201028/64/5f9939c212a46.jpg",
                    training_enter_users: [
                        {
                            "user_id":"25488",
                            "photo":"https://o-yzx.bysjy.com.cn/notice/1596594279-5941.cn/mmopen/vi_32/BTiaVJMOFUdicLkuvOpbftCl1QHibnHuuTn3Ewod3rfVwHmBcibkhrvmOIiaRMYzXaFgzcGLHsnBaYLDwuahxmn45uw/132"
                        }
                    ],
                    training_enter_users_cnt: 1,
                    lecturers:[
                        {
                            user_name: "蒋浩军",
                            photo: "https://o-yzx.bysjy.com.cn/notice/1605607642-6283.cn/mmopen/vi_32/PiasEMichtcAShqaYL50ldy7aIO961xCs288juPPdWZe8aHPP70FyTqhtMk8CR3m9vy4lNeW8gYnzdzjCLnibYZ8w/132",
                            job: "湖南长沙市云研云职训开发",
                            company: "主要课程：【PHP内核分析】",
                        }
                    ],
                    stage_same_term:[],
                    content: "<img src='https://img.fincgo.com/mall/0/20201028/12/5f993ce779757.jpg' /><img src='https://img.fincgo.com/mall/0/20201028/7/5f993d067c27f.jpg' />"
                },
                stage_same_term_price:[], //价格处理
                time: 0,
                curr_order_stage:'',
                curr_order_item:'',
            }
        },
        mounted() {
            // this.util.hideOptionMenu()
            this.init()
            this.$(document).attr('title','训练营')
            this.training_id = this.$route.query.training_id
            this.get_training_detail()
            // this.bindWeiXin();
        },
        methods:{
            init(){
                
            },
            bindWeiXin:function () {
                var _self=this;
                this.util.jweixin(function (wx) {
                    _self.util.wxShare(wx, {
                        title: _self.detail.name,
                        desc: _self.detail.stage_name+'开营了,我们一起去学习吧',
                        link: location.href+'&u_id='+_self.util.getUserId.get(),
                        imgUrl: _self.detail.cover_url
                    });
                });
                //this.bindLists(true);
            },
            bindWeiXin1(){
                var _self=this;
                this.util.jweixin(function (wx) {
                    _self.util.wxShare(wx, {
                        title: '训练营',
                        desc: '训练营',
                        link: location.href,
                        imgUrl: this.util.G_CONFIG.logo
                    });
                });
            },
            usergrantcallback(e){
                //绑定手机号码 回调
                this.visible=false;
                if(e.is_grant){
                    // this.curr_order_stage = training_stage_id
                    // this.curr_order_item = item
                    this.bandOrder(this.curr_order_stage, this.curr_order_item);
                }
            },
            get_training_detail(){
                var _self=this;
                this.util.server.mini_training.get_detail({
                    data:{
                        training_id: this.training_id,
                    },
                    callback:(res => {
                        if(res.data){
                            _self.bodyShow = true
                            let datas = res.data
                            console.log('datas',datas)//data.items && data.items.length>0
                            if(datas){
                                _self.$(document).attr('title',datas.name)
                                _self.detail = datas
                                _self.time = datas.stage_registration_limit_time*1000
                                _self.bindWeiXin()
                                // 当前营期价格数据
                                _self.stage_same_term_price.push({
                                    stage_name: datas.stage_name,
                                    sell_mode: datas.sell_mode,
                                    stage_is_own: datas.stage_is_own,
                                    promotion_money: datas.promotion_money,
                                    money: datas.money,
                                    stage_study_start_date: datas.stage_study_start_date,
                                    training_stage_id: datas.training_stage_id,
                                    stage_apply_status: datas.stage_apply_status,
                                })

                                // 更多营期价格数据
                                datas.stage_same_term.forEach(element => {
                                    console.log(element)
                                    _self.stage_same_term_price.push(
                                        {
                                            stage_name: element.name,
                                            sell_mode: element.sell_mode,
                                            stage_is_own: element.stage_is_own,
                                            promotion_money: element.promotion_money,
                                            money: element.money,
                                            stage_study_start_date: element.stage_study_start_date,
                                            training_stage_id: element.training_stage_id,
                                            stage_apply_status: element.stage_apply_status,
                                        }
                                    )
                                });
                                console.log('datas.stage_same_term_price',_self.stage_same_term_price)

                            }

                        }
                    })
                })
            },
            bandOpenPop(){
                this.popup_show = true
            },
            bandOrder(training_stage_id, item){
                console.log("下订单")
                this.curr_order_stage = training_stage_id
                this.curr_order_item = item

                if(!this.util.user_mobile.get()){
                   return this.visible = true;
                }
                //如果是免费 直接进行购买获取。
                if(item.sell_mode == 2 && item.stage_is_own == 0){
                   this.bindOrderTraing(training_stage_id)
                }else{
                    this.util.payRedirect.set(location.href);
                    location.href = this.util.urlPrefix+'/payment/index?id='+training_stage_id+'&type=2&token='+this.util.token;
                    //this.$router.push(this.util.urlPrefix+'/payment/index?id='+training_stage_id+'&type=2&token='+this.util.token)
                }
            },
            bindToStudents(){
                this.$router.push(this.util.urlPrefix+'/training/students?training_id='+this.training_id+'&type=2&token='+this.util.token)
            },
            bindToPhase(training_stage_id){
                this.$router.push(this.util.urlPrefix+'/training/phase?stage_id='+training_stage_id+'&token='+this.util.token)
            },
            bindOrderTraing(training_stage_id){
                //免费购买情况
                this.util.server.mini_training.order_training({
                    data: {
                        training_stage_id: training_stage_id,
                        pay_money: 0,
                        coupon_user_id: '',
                        sum_money: 0,
                        coupon_money: 0

                    },
                    callback: (res => {
                        if(res.code == 1){
                            location.reload();
                        }else{
                            Toast(res.msg);
                        }
                    })
                })
            },
            
        }
    }

</script>

<style scoped>
    .page{
        padding-bottom: 60px
    }
    .cover{
        width: 100%;
        height: 210px;
        position: relative;
    }
    .cover_recent{
        position: absolute;
        bottom: 0px;
        width: 100%;
        background: rgba(6, 6, 6, 0.7);
        box-sizing: border-box;
    }
    .cover_recent{
        color: #FFF;
        padding: 5px 10px;
    }
    .cover_recent_desc{
        color: #FFF;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 80%;
        font-size: 11px;
        letter-spacing: 1px;
    }
    .cover_recent_name{
        font-weight: 600;
        color: #ffa500;
    }
    .date{
        display: flex;
        justify-content: flex-start;
        height: 40px;
        line-height: 40px;
        background-color: #fdf8f1;
        color: #cf9e69;
    }
    .van-count-down{
        display: inline-block !important;
        /* width: 90px; */
        color: red;
    }
    .date_time{
        padding-left: 10px;
        padding-right: 5px;
    }
    .color_red{
        color: red;
    }
    .info{
        padding: 10px;
        height: 55px;
        display: flex;
        justify-content: space-between;
    }
    .info_left{
        flex: 1;
        display: flex;
    }
    .info_right{
        flex: 1;
    }
    .info_left_item{
        flex: 1;
        text-align: center;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        /* box-shadow: 0 2px 12px 0 rgba(0,0,0,.1); */
    }
    .info_left_num{
        font-size: 21px;
        font-weight: 600;
    }
    .info_left_text{
        font-size: 13px;
        color: #a5a5a5;
    }

    .train-user{
        display: flex;
        justify-content: center;
    }
    .train-user-logo{
        padding-top: 13px;
        margin-right: 15px;
    }
    .train-user-img{
        width: 25px;
        border-radius: 50%;
    }
    .train-user-col{
        font-size: 12px;
        color: #999;
        line-height: 55px;
        height: 55px;
    }
    .mlf15{
        margin-left: -12.5px;
    }
    .teacher-list{

    }
    .teacher-main-wrap{
        padding: 5px 15px ;
    }
    .teacher-main{
        padding: 10px 20px;
        background: #fff;
        border-radius: 8px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
    }
    .top_left{
        height: 100%;
        text-align: center;
    }
    .top_left img{
        width: 50px;
        height: 50px;
        border-radius: 50%;
    }
    .top_right{
        box-sizing: border-box;
        padding-left: 14px;
        width: 80%;
    }
    .top_right_name{
        font-weight: 600;
        font-size: 14px;
    }
    .top_right_position{
        color: #666;
    }
    .top_right_desc{
        margin-top: 8px;
        font-size: 12px;
        color: #666;
    }
    .font-spacing{
        letter-spacing: 1px;
    }
    .detail{
        padding: 15px;
    }
    .detail-content{
        background: #FFF;
        min-height: 150px;
    }
    .detail-content >>> img{
        width: 100% ;
        height: 100%;
        display: block;
    }

    .sameterm{
    /* height: 400px; */
    }
    .section{
        height: 45px;
        line-height: 45px;
        background-color: #FFF;
        padding-left: 10px;
        font-weight: 600;
        border-left: 5px solid #349bf8;
    }
    .sameterm-content{
        padding: 10px 15px 10px;
        background-color: #FFF;
    }
    .sameterm-name{
        height: 30px;
        line-height: 30px;
    }
    .sameterm-desc{
        color: #a5a5a5;
        font-size: 14px;
    }
    .sameterm-time{
        padding: 8px 0px 5px;
        color:orange;
    }
    .sameterm-apply-content{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .sameterm-apply{
        width: 60px;
        font-size: 18px;
        height: 25px;
        line-height: 25px;
        padding: 10px;
        background-color: orange;
        color: white;
        border-radius: 5px;

    }
    .sameterm-info{
        display: flex;
        justify-content: space-around;
        /* box-shadow: 0 1px 5px 0 rgba(105, 99, 99, 0.1); */
        box-shadow: 0 -6px 20px rgba(36,41,48,.08);;
        
    }
    .sameterm-info-item{
        width: 100px;
        display: flex;
        padding: 10px;
    }
    .sameterm-info-text{
        padding-left: 5px;
        font-size: 14px;
        color: #a5a5a5;
        line-height: 30px;
    }
    .sameterm-info-num{
        font-size: 23px;
        font-weight: 600;
    }
    .sameterm-info-wrap{
        overflow: hidden;
        padding-bottom: 5px;
    }
    .bottom{
        position: fixed;
        height: 66px;
        bottom: 0;
        width: 100%;
        z-index: 999;
        display: flex;
        justify-content: space-between;
        background-color: #fff;
        padding: 5px 20px;
        box-sizing: border-box;
        box-shadow: 0 -6px 20px rgba(36,41,48,.08);
    }
    .bottom-op{
        display: flex;
        align-items: center;
    }
    .bottom-name{
        font-size: 14px;
        white-space: nowrap;
        overflow: hidden;
    }
    .bottom-info{
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
    }
    .bottom-price-unit{
        font-size: 12px;
    }
    .bottom-price-num{
        font-size: 16px;
    }
    .bottom-study-unit{
        font-size: 11px;
        color: orange;
    }
    .bottom-price-mark{
        margin-left: 10px;
        font-size: 12px;
        color: #98a4af;
    }
    .bottom-price-mark-num{
        font-size: 12px;
        color: #98a4af;
        text-decoration: line-through;
    }
    .term-item{
        height: 70px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        background-color: #fff;
        box-sizing: border-box;
        /* box-shadow: 0 -6px 20px rgba(36,41,48,.08); */
    }
    .van-divider{
        margin: 10px 0 !important;
    }
    .bottom-op >>> .van-button{
        width: 90px;
    }
</style>